import LoginForm from './login-form.vue'
export default LoginForm
